import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import styles from "./../styles/dashboard.module.scss";
import "./../styles/table.scss";
import {
  AiOutlineSortAscending,
  AiOutlineSortDescending,
} from "react-icons/ai";
import {
  FaSortAmountDown,
  FaSortAmountUp,
  FaSort,
  FaDownload 
} from "react-icons/fa";
import moment from 'moment';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const DashboardTableContainer = ({ UserList, dateFormat, download}) => {
  // Defining default sorting to ascendent
  const defaultSorted = [
    {
      dataField: "name",
      order: "asc"
    }
  ];
  // Defining columns for sorting
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret: order => {
        if (!order)
          return (
            <span className={styles.__sort}>
              <FaSort />
            </span>
          );
        else if (order === "asc")
          return (
            <span className={styles.__sort}>
              <AiOutlineSortAscending />
            </span>
          );
        else if (order === "desc")
          return (
            <span className={styles.__sort}>
              <AiOutlineSortDescending />
            </span>
          );
        return null;
      }
    },
    {
      dataField: "email",
      text: "Email Address",
      sort: true,
      sortCaret: order => {
        if (!order)
          return (
            <span className={styles.__sort}>
              <FaSort />
            </span>
          );
        else if (order === "asc")
          return (
            <span className={styles.__sort}>
              <AiOutlineSortAscending />
            </span>
          );
        else if (order === "desc")
          return (
            <span className={styles.__sort}>
              <AiOutlineSortDescending />
            </span>
          );
        return null;
      }
    },
    {
      dataField: "lastConnection",
      text: "Last Connection",
      sort: true,
      sortCaret: order => {
        if (!order)
          return (
            <span className={styles.__sort}>
              <FaSort />
            </span>
          );
        else if (order === "asc")
          return (
            <span className={styles.__sort}>
              <FaSortAmountDown />
            </span>
          );
        else if (order === "desc")
          return (
            <span className={styles.__sort}>
              <FaSortAmountUp />
            </span>
          );
        return null;
      },
      sortFunc: (a, b, order) => {
        let rowA = moment(a)
        let rowB = moment(b)
        let result = rowA.isBefore(rowB);

        if (order === 'desc') {
          return result ? -1 : 1
        } else {
          return result ? 1 : -1
        }
      },
      formatter: (date) => { return moment(date).format('MM-DD-YYYY HH:mm a')}
    }
  ];

  return (
    <section className={styles.__table}>
      <button 
        title={"Download User List"} 
        className={styles.___csv} 
        value="Download User List"
        onClick={download}
      >
        <FaDownload size={25} color={'#68d2df'}/>
        <span className={styles.__txt_button}>Download User List</span>
      </button> 
      {UserList ? (
        <BootstrapTable defaultSorted={defaultSorted} keyField="email" data={UserList} columns={columns} pagination={paginationFactory() }/>
      ) : (
        "Loading data"
      )}
    </section>
  );
};

export default DashboardTableContainer;
